import { render } from "./logsDetail.vue?vue&type=template&id=1364ba34&scoped=true"
import script from "./logsDetail.vue?vue&type=script&lang=js"
export * from "./logsDetail.vue?vue&type=script&lang=js"

import "./logsDetail.vue?vue&type=style&index=0&id=1364ba34&lang=scss&scoped=true"
import "./logsDetail.vue?vue&type=style&index=1&id=1364ba34&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1364ba34"]])

export default __exports__